import { pushScopeId, popScopeId, openBlock, createElementBlock } from "@histoire/vendors/vue";
import "./HatchedPattern.vue_vue_type_style_index_0_scoped_91561117_lang.js";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const _sfc_main = {};
const _withScopeId = (n) => (pushScopeId("data-v-91561117"), n = n(), popScopeId(), n);
const _hoisted_1 = { class: "__histoire-hatched-pattern" };
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1);
}
const HatchedPattern = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-91561117"]]);
export {
  HatchedPattern as default
};
